import React, { forwardRef } from "react";
import { Link } from 'react-router-dom';
import { MDBDataTableV5 } from "mdbreact";
import moment from "moment";

const DataTablesProject = forwardRef((props, ref) => {
	let data = props.data;
	let finalData = [];

	if (data) {
		for (var index = 0; index < data.length; index++) {
			let rowItem = {};
			rowItem["id"] = index+1;
			rowItem["job_number"] = data[index].job_number;
			rowItem["title"] = data[index].title;
			// rowItem["campaign_name"] = data[index].campaign_name;
			rowItem["client_name"] = data[index].project_client_name ? data[index].project_client_name : 'N/A';
			rowItem["start_date"] =  moment(data[index].project_start_date).format('DD/MM/YYYY'); 
			rowItem["createdAt"] =  moment(data[index].project_end_date).format('DD/MM/YYYY'); 
			rowItem["status"] = data[index].project_status;
      // rowItem["editButton"] = <Link className="btn btn-outline-info" to={`/project/${data[index].id}`}><i className="fa fa-edit"></i></Link>;

		  finalData.push(rowItem);
		}
		//console.log("final data", finalData);
	}
	
//const [datatable, setDatatable] = React.useState({
const datatable = {  
  columns: [
      {
        label: 'Job Number',
        field: 'job_number',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Task Title',
        field: 'title',
        sort: 'asc',
        width: 150
      },
      // {
      //   label: 'Campaign Name',
      //   field: 'campaign_name',
      //   sort: 'asc',
      //   width: 150
      // },
      {
        label: 'Client Name',
        field: 'client_name',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Start Date',
        field: 'start_date',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Due Date',
        field: 'createdAt',
        sort: 'asc',
        width: 150
      },
	    {
        label: 'Status',
        field: 'status',
        width: 150,
		    sort: 'asc'
      } ,
      // {
      //   label: '',
      //   field: 'editButton',
      //   width: 150,
		  //   sort: 'disabled'
      // } 
    ],
    rows: finalData 
	};
  return (
    <MDBDataTableV5 
	   id="mdbDtTable"
        hover
        bordered
        small
        sortable={false}
        striped
        entriesOptions={[5, 10 ,20, 25]} 
        entries={5} 
        pagesAmount={4} 
        searchTop
        data={datatable} 
        searchBottom={false} 
    />

  );
});

export default DataTablesProject;